import { useEffect, useState } from 'react';
import '../styles/ProductRow.scss';
import Carousel from './CustomCarousel';
import CountDown from './CountDown';
import FlipClock from 'x-react-flipclock';

const ProductRow = ({ products , banner , webBanner , colorPrimary,sellTime }) => {
  const [cart, setCart] = useState(null);
  const [cartNumber, setCartNumber] = useState(0);
  const [specialDate,setSpecialDate]=useState(new Date(0));
  var date=new Date(0);
  const isInArray = (source, item) => {
    const checkId = (obj) => obj.id === item.id;
    return source.some(checkId);
  };

  const addToCart = (item) => {
    let newData = [];
    const lsData = JSON.parse(localStorage.getItem('products'));

    if (lsData) {
      if (isInArray(lsData, item)) {
        newData = lsData.filter((product) => product.id !== item.id);
      } else {
        

        newData = [...lsData, item];
      }
    } else {
      newData = [item];
    }
    let counterss=0
    newData.map(()=>{
      counterss++;
    })
    document.querySelector(".cart-number").innerHTML=counterss;
    setCart(newData);
    localStorage.setItem('products', JSON.stringify(newData));
  };

  useEffect(()=>{
   
    if(sellTime){
        let d = new Date(0); 
        d.setUTCSeconds(sellTime);
        setSpecialDate(d);
        date=d;
      }
  },[])

  useEffect(() => {
    setCart(() => {
      return JSON.parse(localStorage.getItem('products'));
    });
  }, []);
  return (
    <>
    {banner &&
      <div className='Product-row md:flex block bg-amber-400' >
        <div className='md:w-80 flex web-banner relative'>
          {/* <CountDown sellTime={sellTime} /> */}
          <div className='count-down'>
          <FlipClock 
            type = "countdown"
            count_to = {
              specialDate.getFullYear()+"-"+
              (specialDate.getMonth()+1)+"-"+specialDate.getDate()+" "+
              specialDate.getHours()+":"+specialDate.getMinutes()+":"+
              specialDate.getSeconds()
          }
            units = {[
              {
                sep: '',
                type: 'days',
                title: 'روز',
              },
              {
                sep: ' ',
                type: 'hours',
                title: 'ساعت',
              },
              {
                sep: ':',
                type: 'minutes',
                title: 'دقیقه',
              },
              {
                sep: ':',
                type: 'seconds',
                title: 'ثانیه',
              }
            ]}
          />
          </div>
          <img className='md:hidden block object-cover' src={banner} />
          <img className='md:block hidden object-cover' src={webBanner} />
        </div>
        <div className='md:w-5/6 '><Carousel data={products} addToCart={addToCart} cart={cart} /></div>
      </div>
    }
    {!banner && <div className='Product-row'><Carousel data={products} addToCart={addToCart} cart={cart} /></div>}
    </>
  );
};

export default ProductRow;
